
export const portal_urls = [
    'https://hubs.superunion.co/CCoA8Eh/lobby'
];
